/* Veluna storefront behaviour. No dependencies. */
(function () {
  'use strict';
  var V = window.Veluna || {};
  var PREVIEW = !!window.VELUNA_PREVIEW;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = V.money || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  /* Before / after sliders */
  $$('[data-ba-slider]').forEach(function (el) {
    var r = $('.ba__range', el);
    if (!r) return;
    r.addEventListener('input', function () { el.style.setProperty('--pos', r.value + '%'); });
  });

  /* Before / after filters */
  $$('[data-ba-gallery]').forEach(function (g) {
    var state = { product: 'all', cup: 'all', outfit: 'all' };
    var cards = $$('[data-ba]', g);
    var count = $('[data-ba-count]', g);
    var empty = $('[data-ba-empty]', g);
    var more = $('[data-ba-more]', g);
    var pageSize = parseInt(g.getAttribute('data-page-size') || '12', 10);
    var shown = pageSize;
    function apply() {
      var matches = 0;
      cards.forEach(function (c) {
        var ok = ['product', 'cup', 'outfit'].every(function (k) {
          return state[k] === 'all' || (c.getAttribute('data-' + k) || '').split(' ').indexOf(state[k]) > -1 || c.getAttribute('data-' + k) === state[k];
        });
        if (ok) matches++;
        c.hidden = !ok || matches > shown;
      });
      if (count) count.textContent = matches + (matches === 1 ? ' look' : ' looks');
      if (empty) empty.hidden = matches > 0;
      if (more) more.hidden = matches <= shown;
    }
    $$('[data-filter]', g).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-filter');
        state[k] = b.getAttribute('data-value');
        $$('[data-filter="' + k + '"]', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        shown = pageSize;
        apply();
      });
    });
    if (more) more.addEventListener('click', function () { shown += pageSize; apply(); });
    apply();
  });

  /* Cart (Shopify AJAX API, or an in-memory cart in the static preview) */
  var memCart = { items: [], total_price: 0, item_count: 0 };
  var productCache = {};
  $$('[data-product-json]').forEach(function (s) { try { var p = JSON.parse(s.textContent); productCache[p.id] = p; } catch (e) {} });
  function findVariant(id) {
    for (var k in productCache) {
      var p = productCache[k];
      for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(id)) return { p: p, v: p.variants[i] };
    }
    return null;
  }
  function recalc() {
    memCart.total_price = memCart.items.reduce(function (a, i) { return a + i.price * i.quantity; }, 0);
    memCart.item_count = memCart.items.reduce(function (a, i) { return a + i.quantity; }, 0);
    return memCart;
  }
  var cart = {
    get: function () {
      if (PREVIEW) return Promise.resolve(recalc());
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },
    add: function (id, qty) {
      if (PREVIEW) {
        var f = findVariant(id), ex = memCart.items.filter(function (i) { return String(i.variant_id) === String(id); })[0];
        if (ex) ex.quantity += qty;
        else if (f) memCart.items.push({ key: String(id), variant_id: id, quantity: qty, price: f.v.price, product_title: f.p.title, variant_title: f.v.title === 'Default Title' ? '' : f.v.title, image: null });
        return Promise.resolve(recalc());
      }
      return fetch((V.routes && V.routes.cart_add) || '/cart/add', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () { return cart.get(); });
    },
    change: function (key, qty) {
      if (PREVIEW) {
        memCart.items = memCart.items.map(function (i) { if (i.key === key) i.quantity = qty; return i; }).filter(function (i) { return i.quantity > 0; });
        return Promise.resolve(recalc());
      }
      return fetch((V.routes && V.routes.cart_change) || '/cart/change', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
    }
  };

  var drawer = $('[data-drawer]');
  function renderShip(total) {
    var th = V.freeShipCents || 3500;
    $$('[data-ship-meter]').forEach(function (m) {
      var bar = $('[data-ship-bar]', m), msg = $('[data-ship-msg]', m);
      var pct = Math.min(100, Math.round((total / th) * 100));
      if (bar) bar.style.width = pct + '%';
      if (msg) msg.textContent = total >= th ? 'You unlocked free U.S. shipping.' : (total > 0 ? 'You are ' + money(th - total) + ' away from free U.S. shipping.' : 'Free U.S. shipping on orders over ' + money(th).replace('.00', ''));
    });
  }
  function renderCart(c) {
    $$('[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; });
    renderShip(c.total_price);
    if (!drawer) return;
    var lines = $('[data-cart-lines]', drawer);
    $('[data-cart-empty]', drawer).hidden = c.item_count > 0;
    $('[data-cart-total]', drawer).textContent = money(c.total_price);
    lines.innerHTML = '';
    c.items.forEach(function (i) {
      var d = document.createElement('div');
      d.className = 'line';
      var img = i.image ? '<img src="' + i.image + '" alt="">' : '';
      d.innerHTML = '<div class="line__img">' + img + '</div><div><div class="line__t"></div><div class="line__v"></div><div class="qty"><button type="button" aria-label="Decrease quantity" data-q="-1">−</button><span></span><button type="button" aria-label="Increase quantity" data-q="1">+</button></div></div><div class="line__p"></div>';
      $('.line__t', d).textContent = i.product_title;
      $('.line__v', d).textContent = i.variant_title || '';
      $('.qty span', d).textContent = i.quantity;
      $('.line__p', d).textContent = money(i.price * i.quantity);
      $$('[data-q]', d).forEach(function (b) {
        b.addEventListener('click', function () { cart.change(i.key, Math.max(0, i.quantity + parseInt(b.getAttribute('data-q'), 10))).then(renderCart); });
      });
      lines.appendChild(d);
    });
  }
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); var c = $('.drawer__close', drawer); if (c) c.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); cart.get().then(renderCart); openDrawer(); }); });
  var up = $('[data-upsell]');
  if (up) $('[data-upsell-add]', up).addEventListener('click', function () { cart.add(up.getAttribute('data-variant'), 1).then(renderCart); });
  cart.get().then(renderCart).catch(function () {});

  /* Buy boxes */
  $$('[data-buy]').forEach(function (box) {
    var json = $('[data-product-json]', box);
    if (!json) return;
    var p = JSON.parse(json.textContent);
    var form = $('[data-buy-form]', box);
    var idInput = $('[data-variant-id]', box);
    function selected() { return $$('fieldset[data-option-index]', box).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function packCount(v) { var m = String(v || '').match(/(\d+)/); return m ? parseInt(m[1], 10) : 1; }
    function update() {
      var sel = selected();
      var v = p.variants.filter(function (x) { return sel.every(function (s, i) { return s === null || x.options[i] === s; }); })[0];
      $$('fieldset[data-option-index]', box).forEach(function (fs) {
        var l = $('[data-selected-label]', fs), c = $('input:checked', fs);
        if (l && c) l.textContent = c.value;
      });
      if (!v) { $('[data-atc]', box).disabled = true; $('[data-atc-label]', box).textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      $('[data-price]', box).textContent = money(v.price);
      $('[data-atc-price]', box).textContent = money(v.price);
      var cmp = $('[data-compare]', box), save = $('[data-save]', box);
      var has = v.compare_at_price && v.compare_at_price > v.price;
      cmp.hidden = save.hidden = !has;
      if (has) { cmp.textContent = money(v.compare_at_price); save.textContent = 'Save ' + money(v.compare_at_price - v.price).replace('.00', ''); }
      $('[data-atc]', box).disabled = !v.available;
      $('[data-atc-label]', box).textContent = v.available ? (form.getAttribute('data-atc-text') || 'Add to bag') : 'Sold out';
      /* per-unit line on bundle tiers */
      $$('[data-tier-sub]', box).forEach(function (el) {
        var val = el.getAttribute('data-tier-sub');
        var tv = p.variants.filter(function (x) { return x.options.indexOf(val) > -1; })[0];
        if (!tv) return;
        var n = packCount(val);
        el.textContent = n > 1 ? money(Math.round(tv.price / n)) + ' each' : 'One pair to try';
      });
      var st = $('[data-sticky-price]');
      if (st) st.textContent = money(v.price);
    }
    var qs = (location.search.match(/[?&]size=([A-Za-z]+)/) || [])[1];
    if (qs) $$('fieldset[data-option-index] input', box).forEach(function (i) { if (i.value.toUpperCase() === qs.toUpperCase()) i.checked = true; });
    form.setAttribute('data-atc-text', $('[data-atc-label]', box).textContent.trim());
    box.addEventListener('change', update);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-atc]', box), label = $('[data-atc-label]', box), prev = label.textContent;
      btn.disabled = true; label.textContent = 'Adding…';
      cart.add(idInput.value, 1).then(function (c) { renderCart(c); openDrawer(); label.textContent = prev; btn.disabled = false; })
        .catch(function (err) { label.textContent = (err && err.description) || 'Could not add. Try again.'; btn.disabled = false; });
    });
    update();
  });

  /* Sticky add-to-cart */
  var sticky = $('[data-sticky-atc]');
  var mainBuy = $('[data-buy]');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky');
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe($('[data-atc]', mainBuy));
    $('[data-sticky-go]', sticky).addEventListener('click', function () { mainBuy.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }

  /* Gallery thumbs */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g);
    $$('[data-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        main.innerHTML = t.innerHTML;
        $$('[data-thumb]', g).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });
  });

  /* Mobile menu */
  var mb = $('[data-menu-btn]'), mn = $('[data-mnav]');
  if (mb && mn) mb.addEventListener('click', function () { var o = mn.hidden; mn.hidden = !o; mb.setAttribute('aria-expanded', o ? 'true' : 'false'); });

  /* Size finder: bra size (e.g. 34B) -> Veluna size, per product */
  $$('[data-finder]').forEach(function (f) {
    var map = {};
    try { map = JSON.parse($('[data-finder-map]', f).textContent); } catch (e) {}
    var sel = $('[data-finder-bra]', f), out = $('[data-finder-out]', f), size = $('[data-finder-size]', f), note = $('[data-finder-note]', f), cta = $('[data-finder-cta]', f);
    var cupOrder = ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'G'];
    function parse(bs) { var m = String(bs).trim().toUpperCase().match(/^(\d{2})([A-Z]+)$/); return m ? { band: +m[1], cup: m[2], key: m[1] + m[2] } : null; }
    function product() { var r = $('[data-finder-product]:checked', f) || $('[data-finder-product-fixed]', f); return r ? r.value : 'pop'; }
    function lookup(p) {
      var idx = {}, all = {};
      Object.keys(map[p] || {}).forEach(function (vs) {
        String(map[p][vs] || '').split(/[,\u00b7;]+/).forEach(function (x) { var b = parse(x); if (b) { idx[b.key] = vs; all[b.key] = b; } });
      });
      ['pop', 'popup'].forEach(function (q) { Object.keys(map[q] || {}).forEach(function (vs) { String(map[q][vs] || '').split(/[,\u00b7;]+/).forEach(function (x) { var b = parse(x); if (b) all[b.key] = b; }); }); });
      return { idx: idx, all: Object.keys(all).map(function (k) { return all[k]; }).sort(function (a, b) { return a.band - b.band || cupOrder.indexOf(a.cup) - cupOrder.indexOf(b.cup); }) };
    }
    function fill() {
      var keep = sel.value, L = lookup(product());
      sel.innerHTML = '<option value="">Choose your bra size</option>' + L.all.map(function (b) { return '<option value="' + b.key + '">' + b.key + '</option>'; }).join('');
      if (keep) sel.value = keep;
      show();
    }
    function show() {
      var p = product(), L = lookup(p), v = sel.value;
      if (!v) { out.hidden = true; return; }
      out.hidden = false;
      var vs = L.idx[v];
      if (!vs) {
        var other = p === 'pop' ? 'popup' : 'pop', o = lookup(other).idx[v];
        size.textContent = 'Not in ' + map.names[p] + ' yet';
        note.textContent = o ? 'Good news: ' + map.names[other] + ' comes in your fit (Size ' + o + ').' : 'We don\'t make this fit yet. We would rather tell you now than send something that won\'t fit.';
        cta.hidden = !o; if (o) { cta.href = map.urls[other] + '?size=' + o; cta.textContent = 'Shop ' + map.names[other] + ' Size ' + o; }
        return;
      }
      size.textContent = map.names[p] + ' Size ' + vs;
      note.textContent = 'Size ' + vs + ' is made for your ' + v + '.';
      cta.hidden = false; cta.href = map.urls[p] + '?size=' + vs; cta.textContent = 'Shop ' + map.names[p] + ' Size ' + vs;
    }
    f.addEventListener('change', function (e) { if (e.target.hasAttribute('data-finder-product')) fill(); else show(); });
    fill();
  });

  /* Pop or Pop Up quiz */
  $$('[data-quiz]').forEach(function (q) {
    var steps = $$('[data-q-step]', q), score = { pop: 0, 'pop-up': 0 }, i = 0, prog = $$('.quiz__prog i', q);
    function show() { steps.forEach(function (s, k) { s.hidden = k !== i; }); prog.forEach(function (p, k) { p.classList.toggle('on', k <= i); }); }
    $$('[data-q-vote]', q).forEach(function (b) {
      b.addEventListener('click', function () {
        b.getAttribute('data-q-vote').split(',').forEach(function (v) { if (score[v] !== undefined) score[v]++; });
        i++;
        if (i >= steps.length - 1) {
          var win = score['pop-up'] > score.pop ? 'pop-up' : 'pop';
          $$('[data-q-result]', q).forEach(function (r) { r.hidden = r.getAttribute('data-q-result') !== win; });
        }
        show();
      });
    });
    var rs = $('[data-q-restart]', q);
    if (rs) rs.addEventListener('click', function () { i = 0; score = { pop: 0, 'pop-up': 0 }; show(); });
    show();
  });

  /* Countdown to a fixed date/time set in the section */
  $$('[data-countdown]').forEach(function (c) {
    var end = new Date(c.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) { c.hidden = true; return; }
    var parts = $$('span', c);
    function tick() {
      var d = Math.max(0, end - Date.now());
      var v = [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
      parts.forEach(function (p, k) { p.textContent = String(v[k]).padStart(2, '0') + ['d', 'h', 'm', 's'][k]; });
      if (d <= 0) { var w = c.closest('[data-countdown-wrap]'); if (w) w.hidden = true; return; }
      setTimeout(tick, 1000);
    }
    tick();
  });
})();
